import * as t from 'io-ts';

import {makeEnumTypeGuard} from '../../../libs/shared/helpers/src/typescript/enumHelpers';
import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

export enum SpecialRoleAliasesEnum {
  ADMIN = 'admin',
  DELEGATE_ADMIN = 'delegateAdmin',
  MEMBER = 'member',
  GUEST = 'guest',
  NONE = 'none',
}

export enum PermissionsEnum {
  APPLY_TAG = 'tag.apply',
  BLOCK_CONTACT = 'contact.block',
  CONVERSATION_ARCHIVE = 'conversation.update.archive',
  CONVERSATION_ASSIGN = 'conversation.update.assign',
  CONVERSATION_COMMENT = 'conversation.comment',
  CONVERSATION_DESTROY = 'conversation.update.destroy',
  CONVERSATION_MESSAGE = 'conversation.message',
  CONVERSATION_MOVE = 'conversation.update.move',
  CONVERSATION_TRASH = 'conversation.update.trash',
  CREATE_INBOX = 'inbox.create',
  CREATE_VIEW = 'view.create',
  EDIT_CANNED_ANSWER = 'cannedAnswer.edit',
  EDIT_CARD = 'card.edit',
  EDIT_CARD_GROUP = 'cardGroup.edit',
  EDIT_CARD_NOTE = 'cardNote.edit',
  EDIT_RECIPIENT = 'recipient.edit',
  EDIT_SEQUENCE = 'sequence.edit',
  EDIT_SEQUENCE_RECIPIENT = 'sequenceRecipient.edit',
  EDIT_STAGE = 'stage.edit',
  EDIT_TAG = 'tag.edit',
  EDIT_TEAMMATE = 'teammate.edit',
  EDIT_SHIFT = 'shift.edit',
  EDIT_VIEW = 'view.edit',
  EDIT_TOPIC = 'topic.edit',
  READ_ACTIVITY = 'activity.read',
  READ_ANALYTICS = 'analytics.read',
  READ_AUDIT = 'audit.read',
  READ_CONTACT = 'contact.read',
  READ_DELAYED_JOB = 'delayedJob.read',
  READ_INBOX = 'inbox.read',
  READ_INTEGRATION = 'integration.read',
  READ_ROLE = 'role.read',
  READ_SEQUENCE = 'sequence.read',
  READ_SIGNATURE = 'signature.read',
  READ_TEAM = 'team.read',
  READ_TEAMMATE = 'teammate.read',
  RULE_UPDATE = 'rule.update',
  VIEW_INBOX_CONTENT = 'inbox.content',
  TAG_UPDATE = 'tag.update',
  CANNED_ANSWER_UPDATE = 'cannedAnswer.update',
  TEAMMATE_UPDATE = 'teammate.update',
  INBOX_UPDATE = 'inbox.update',
  CUSTOM_VIEW_EDIT = 'customView.edit',
  SIGNATURE_UPDATE = 'signature.update',
  ROLE_UPDATE = 'role.update',
}

export const isPermissionsEnum = makeEnumTypeGuard(PermissionsEnum);

const RRoleDirty = t.readonly(
  t.type({
    alias: t.string,
    name: t.string,
    isSpecial: t.boolean,
    permissions: t.readonlyArray(t.string),
    updatedAt: t.Integer,
    namespace: t.union([t.null, t.string]),
  }),
  'role',
);

/*
 * Type.
 */

export interface RoleModel extends t.TypeOf<typeof RRoleDirty> {}
export const RRole = t.clean<RoleModel>(RRoleDirty as any);

/*
 * IO methods.
 */

export function parseRole(src: any): RoleModel {
  return {
    alias: src.alias,
    name: src.name,
    isSpecial: src.special,
    permissions: src.permissions,
    updatedAt: src.updated_at || 0,
    namespace: src.namespace || null,
  };
}

/*
 * API type.
 */

export const ApiRole = makeApiType('role', RRole, parseRole);
